var quickViewOpener = null;
var quickViewDialog = null;
var quickViewHiddenNodes = [];
var pendingThumbNavRestore = null;

/**
 * Trapping Tab is not enough for VoiceOver: Control+Option+arrow walks the
 * accessibility tree and will happily step out of the dialog into whatever
 * follows it in the DOM, such as the floating reviews tab. Hiding everything
 * beside the dialog is what actually keeps that navigation inside it.
 * Overlays that can legitimately open on top of the quick view stay exposed.
 */
var QUICK_VIEW_KEEP_EXPOSED = '#popup-quickview, .pdp_details_drawer, #sidebar-cart, [aria-live], [role="alert"]';
var QUICK_VIEW_UNRENDERED_TAGS = ['SCRIPT', 'STYLE', 'LINK', 'NOSCRIPT', 'TEMPLATE'];

function hidePageFromScreenReaders() {
    var popup = document.getElementById('popup-quickview');
    if (!popup || !document.body) return;

    releasePageFromScreenReaders();

    Array.prototype.forEach.call(document.body.children, function(node) {
        if (node === popup || node.contains(popup)) return;
        if (QUICK_VIEW_UNRENDERED_TAGS.indexOf(node.tagName) !== -1) return;
        if (node.matches && node.matches(QUICK_VIEW_KEEP_EXPOSED)) return;

        quickViewHiddenNodes.push({ node: node, previous: node.getAttribute('aria-hidden') });
        node.setAttribute('aria-hidden', 'true');
    });
}

function releasePageFromScreenReaders() {
    quickViewHiddenNodes.forEach(function(entry) {
        if (entry.previous === null) {
            entry.node.removeAttribute('aria-hidden');
        } else {
            entry.node.setAttribute('aria-hidden', entry.previous);
        }
    });
    quickViewHiddenNodes = [];
}

function getQuickViewTabbables(container) {
    if (!container) return [];
    var nodes = container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), lensadvizor-quick-buy, [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(nodes, function(el) {
        if (el.classList.contains('Product__SlideItem') || el.closest('.Product__Tabs')) return false;
        if (el.classList.contains('flickity-clone') || el.closest('.flickity-clone')) return false;
        if (el.closest('.Product__SlideshowNav--thumbnails, .Product__SlideshowMobileNav, .Product__ActionList')) return false;
        if (el.closest('.Product__Slideshow .flickity-slider')) return false;
        if (el.getAttribute('tabindex') === '-1') return false;
        if (el.classList.contains('qv-thumb-nav-prev') || el.classList.contains('qv-thumb-nav-next')) {
            return !el.disabled && el.tabIndex !== -1;
        }
        if (el.classList.contains('navigationthumbnail--media')) {
            return !el.classList.contains('flickity-clone') && el.getAttribute('tabindex') !== '-1';
        }
        if (el.classList.contains('quickview-pdp') || el.classList.contains('prescriptionRedirect') || el.tagName === 'LENSADVIZOR-QUICK-BUY') {
            return el.offsetWidth > 0 && el.offsetHeight > 0;
        }
        return el.offsetWidth > 0 && el.offsetHeight > 0 && window.getComputedStyle(el).visibility !== 'hidden';
    });
}

function getQuickViewMainSlideshow() {
    return document.querySelector('.quick-view-inner .Product__Slideshow');
}

function getQuickViewCarousel() {
    var carousel = getQuickViewMainSlideshow() || document.querySelector('.quick-view-inner .Carousel.flickity-enabled');
    return carousel && typeof Flickity !== 'undefined' ? Flickity.data(carousel) : null;
}

function highlightQuickViewThumbnail(index) {
    var slider = document.querySelector('.quick-view-container .thumbnail--slider-product');
    if (!slider) return;
    var cells = Array.prototype.filter.call(
        slider.querySelectorAll('.navigationthumbnail--media'),
        function (cell) { return !cell.classList.contains('flickity-clone'); }
    );
    cells.forEach(function (cell, i) {
        if (i === index) cell.classList.add('is-selected');
        else cell.classList.remove('is-selected');
    });
}

function navigateQuickViewSlideshow(direction) {
    var flkty = getQuickViewCarousel();
    if (!flkty) return;
    if (direction === 'next') flkty.next();
    else flkty.previous();
    highlightQuickViewThumbnail(flkty.selectedIndex);
}

function isQuickViewSlideshowPrev(btn) {
    return btn.classList.contains('Product__SlideshowNavArrow--previous')
        || btn.getAttribute('data-action') === 'carousel-previous'
        || btn.getAttribute('data-direction') === 'previous';
}

function isQuickViewSlideshowNext(btn) {
    return btn.classList.contains('Product__SlideshowNavArrow--next')
        || btn.getAttribute('data-action') === 'carousel-next'
        || btn.getAttribute('data-direction') === 'next';
}

function syncQuickViewSlideshowNav(flkty) {
    var root = document.querySelector('.quick-view-inner');
    if (!root) return;
    flkty = flkty || getQuickViewCarousel();
    var buttons = root.querySelectorAll(
        '.Product__SlideshowCarouselControl, .Product__SlideshowNavArrow, [data-action="carousel-previous"], [data-action="carousel-next"]'
    );
    var wrap = !flkty || !!(flkty.options && flkty.options.wrapAround);
    var index = flkty ? flkty.selectedIndex : 0;
    var last = flkty && flkty.slides ? flkty.slides.length - 1 : 0;
    Array.prototype.forEach.call(buttons, function (btn) {
        if (btn.closest('.thumbnail--slider-product, .qv-thumb-nav, .flyout-ycab, .Product__SlideshowNav--thumbnails')) return;
        var isPrev = isQuickViewSlideshowPrev(btn);
        var isNext = isQuickViewSlideshowNext(btn);
        if (!isPrev && !isNext) return;
        var shouldDisable = !wrap && flkty && ((isPrev && index <= 0) || (isNext && index >= last));
        btn.disabled = shouldDisable;
        if (shouldDisable) btn.setAttribute('disabled', 'disabled');
        else btn.removeAttribute('disabled');
        btn.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
    });
}

function isDetailsDrawerOpen() {
    return document.querySelector('.pdp_details_drawer.pdp_dr_active') !== null;
}

function onQuickViewKeydown(event) {
    if (!quickViewDialog || !document.querySelector('.quick-view-popup.active')) return;
    if (isDetailsDrawerOpen()) return;
    if (event.key === 'Escape') {
        event.preventDefault();
        closeQuickView();
        return;
    }
    var carouselEl = quickViewDialog.querySelector('.quick-view-inner .Carousel.flickity-enabled');
    var flickity = getQuickViewCarousel();
    var focusOnCarousel = carouselEl && (document.activeElement === carouselEl || (carouselEl.contains(document.activeElement) && document.activeElement !== quickViewDialog.querySelector('.close-quickview')));
    if ((event.key === 'ArrowRight' || event.key === 'ArrowLeft') && flickity && focusOnCarousel) {
        event.preventDefault();
        if (event.key === 'ArrowRight') flickity.next();
        else flickity.previous();
        return;
    }
    if (event.key !== 'Tab') return;
    document.body.classList.add('is-tabbing');
    if (handleThumbCarouselTab(event)) return;
    var tabbables = getQuickViewTabbables(quickViewDialog);
    if (tabbables.length < 2) return;
    var first = tabbables[0];
    var last = tabbables[tabbables.length - 1];
    var current = document.activeElement;
    if (event.shiftKey) {
        if (current === first || !quickViewDialog.contains(current)) {
            event.preventDefault();
            last.focus();
        }
    } else if (current === last || !quickViewDialog.contains(current)) {
        event.preventDefault();
        first.focus();
    }
}

function focusQuickViewClose() {
    if (!document.querySelector('.quick-view-popup.active') || isDetailsDrawerOpen()) return;
    var closeBtn = document.querySelector('.quick-view-container .close-quickview');
    if (!closeBtn) return;
    closeBtn.setAttribute('tabindex', '0');
    closeBtn.focus();
}

function ensureQuickViewTabControlsA11y() {
    if (!quickViewDialog) return;
    var tabsList = quickViewDialog.querySelector('.product-tabs.product-tabs-header');
    if (tabsList) {
        tabsList.setAttribute('role', 'list');
    }

    var tabItems = quickViewDialog.querySelectorAll('.product-tabs.product-tabs-header > .product-tabs-accordion-item');
    Array.prototype.forEach.call(tabItems, function(item) {
        item.setAttribute('role', 'listitem');
        var trigger = item.querySelector('.product-tabs-header-item');
        if (!trigger) return;
        trigger.setAttribute('aria-haspopup', 'dialog');
        if (!trigger.hasAttribute('aria-controls')) {
            trigger.setAttribute('aria-controls', 'pdp-details-drawer-dialog');
        }
    });
}

function prepareQuickViewCarousel() {
    if (!quickViewDialog) return;
    quickViewDialog.querySelectorAll('.quick-view-inner .Product__SlideItem').forEach(function(el) {
        el.setAttribute('tabindex', '-1');
    });
    var carousel = quickViewDialog.querySelector('.quick-view-inner .Product__Slideshow.Carousel, .quick-view-inner .Carousel');
    if (!carousel) return;
    var titleEl = quickViewDialog.querySelector('.ProductMeta__Title');
    var title = titleEl ? titleEl.textContent.trim() : '';
    carousel.setAttribute('tabindex', '0');
    carousel.setAttribute('role', 'group');
    carousel.setAttribute('aria-roledescription', 'carousel');
    carousel.setAttribute('aria-label', title ? title + ' images' : 'Product images');
    labelQuickViewMainSlides(carousel, title || 'Product');
}

function buildCarouselImageLabel(rawAlt, title, index, count) {
    var alt = (rawAlt || '').trim();
    // Avoid duplicated suffixes like ", image 1 of 10, image 1 of 10"
    alt = alt.replace(/\s*,?\s*image\s+\d+\s+of\s+\d+\s*$/i, '').trim();
    if (!alt || alt.toLowerCase() === title.toLowerCase()) {
        alt = title;
    }
    return alt + ', image ' + (index + 1) + ' of ' + count;
}

function labelQuickViewMainSlides(carousel, title) {
    if (!carousel) return;
    var slides = Array.prototype.filter.call(
        carousel.querySelectorAll('.Product__SlideItem'),
        function(slide) { return !slide.classList.contains('flickity-clone'); }
    );
    var count = slides.length;
    slides.forEach(function(slide, index) {
        var img = slide.querySelector('img');
        var label = buildCarouselImageLabel(img ? img.getAttribute('alt') : '', title, index, count);
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', label);
        // Let slide provide name; image alt would otherwise be read separately.
        if (img) img.setAttribute('alt', '');
    });
}

function isThumbCellFullyVisible(viewportEl, cell) {
    if (!viewportEl || !cell || cell.classList.contains('flickity-clone')) return false;
    var view = viewportEl.getBoundingClientRect();
    var box = cell.getBoundingClientRect();
    if (box.width < 1 || box.height < 1) return false;
    var tol = 2;
    return box.left >= view.left - tol && box.right <= view.right + tol;
}

function getRealThumbCells(flkty) {
    if (!flkty) return [];
    return flkty.getCellElements().filter(function(cell) {
        return !cell.classList.contains('flickity-clone');
    });
}

function getVisibleThumbCells(flkty) {
    if (!flkty || !flkty.element) return [];
    var viewport = flkty.viewport || flkty.element;
    var cells = getRealThumbCells(flkty).filter(function(cell) {
        return isThumbCellFullyVisible(viewport, cell);
    });
    return cells.sort(function(a, b) {
        return a.getBoundingClientRect().left - b.getBoundingClientRect().left;
    });
}

function getThumbNavButtons() {
    var container = document.querySelector('.quick-view-container');
    if (!container) return { prev: null, next: null };
    return {
        prev: container.querySelector('.qv-thumb-nav-prev'),
        next: container.querySelector('.qv-thumb-nav-next')
    };
}

function getThumbBounds(flkty) {
    var all = getRealThumbCells(flkty);
    var visible = getVisibleThumbCells(flkty);
    return {
        all: all,
        visible: visible,
        atStart: !!(all.length && visible.length && visible[0] === all[0]),
        atEnd: !!(all.length && visible.length && visible[visible.length - 1] === all[all.length - 1])
    };
}

function updateThumbNavButtons(flkty) {
    var buttons = getThumbNavButtons();
    if (!buttons.prev || !buttons.next || !flkty) return;
    var bounds = getThumbBounds(flkty);
    if (!bounds.visible.length) return;
    var focusEl = document.activeElement;
    var nextHeld = focusEl === buttons.next;
    var prevHeld = focusEl === buttons.prev;
    // Disabling a focused button drops focus to the document. Keep the
    // active control enabled until restoreThumbNavFocus moves away.
    buttons.prev.disabled = bounds.atStart && !prevHeld;
    buttons.next.disabled = bounds.atEnd && !nextHeld;
    if (!nextHeld) buttons.next.tabIndex = bounds.atEnd ? -1 : 0;
    if (!prevHeld) buttons.prev.tabIndex = bounds.atStart ? -1 : 0;
}

function restoreThumbNavFocus(direction) {
    if (pendingThumbNavRestore !== direction) return;
    pendingThumbNavRestore = null;
    var flkty = getThumbFlickity();
    var buttons = getThumbNavButtons();
    if (!flkty || !buttons.prev || !buttons.next) return;
    var active = document.activeElement;
    var stillOnNav = active === buttons.next || active === buttons.prev ||
        active === document.body || (quickViewDialog && active === quickViewDialog);
    if (!stillOnNav) return;
    var bounds = getThumbBounds(flkty);
    if (direction === 'next') {
        if (bounds.atEnd && bounds.visible.length) {
            bounds.visible[bounds.visible.length - 1].focus();
        } else {
            buttons.next.disabled = false;
            buttons.next.tabIndex = 0;
            buttons.next.focus();
        }
    } else if (bounds.atStart && bounds.visible.length) {
        bounds.visible[0].focus();
    } else {
        buttons.prev.disabled = false;
        buttons.prev.tabIndex = 0;
        buttons.prev.focus();
    }
    updateThumbNavButtons(flkty);
}

function syncThumbCarouselAria(flkty) {
    if (!flkty || !flkty.element) return;
    var visible = getVisibleThumbCells(flkty);
    flkty.getCellElements().forEach(function(cell) {
        if (cell.classList.contains('flickity-clone')) {
            cell.setAttribute('aria-hidden', 'true');
            cell.setAttribute('tabindex', '-1');
            return;
        }
        var inView = visible.indexOf(cell) !== -1;
        cell.setAttribute('aria-hidden', inView ? 'false' : 'true');
        cell.setAttribute('tabindex', inView ? '0' : '-1');
    });
    var track = flkty.element.querySelector('.flickity-slider');
    if (track) {
        track.setAttribute('aria-live', 'off');
        track.setAttribute('aria-atomic', 'false');
    }
    updateThumbNavButtons(flkty);
}

function getThumbFlickity(fromEl) {
    var slider = null;
    if (fromEl) {
        slider = fromEl.closest('.thumbnail--slider-product');
        if (!slider) {
            var nav = fromEl.closest('.qv-thumb-nav');
            if (nav && nav.parentElement) {
                slider = nav.parentElement.querySelector('.thumbnail--slider-product');
            }
        }
    }
    if (!slider) {
        slider = document.querySelector('.quick-view-container .thumbnail--slider-product');
    }
    return slider && typeof Flickity !== 'undefined' ? Flickity.data(slider) : null;
}

function isThumbFlowElement(el) {
    if (!el || !el.classList) return false;
    return el.classList.contains('navigationthumbnail--media') ||
        el.classList.contains('qv-thumb-nav-next') ||
        el.classList.contains('qv-thumb-nav-prev');
}

function focusAdjacentDialogControl(current, backwards) {
    if (!quickViewDialog) return;
    var tabbables = getQuickViewTabbables(quickViewDialog).filter(function(el) {
        return !isThumbFlowElement(el);
    });
    if (!tabbables.length) return;
    var following = [];
    var preceding = [];
    tabbables.forEach(function(el) {
        if (el === current) return;
        var pos = current.compareDocumentPosition(el);
        if (pos & Node.DOCUMENT_POSITION_FOLLOWING) following.push(el);
        else preceding.push(el);
    });
    var target = backwards
        ? (preceding.length ? preceding[preceding.length - 1] : tabbables[tabbables.length - 1])
        : (following.length ? following[0] : tabbables[0]);
    if (target) target.focus();
}

function isVisiblyFocusable(el) {
    if (!el || el.disabled) return false;
    if (el.getAttribute('aria-hidden') === 'true') return false;
    if (el.getAttribute('tabindex') === '-1') return false;
    if (el.closest('[hidden], .u-visually-hidden')) return false;
    var style = window.getComputedStyle(el);
    if (style.visibility === 'hidden' || style.display === 'none') return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 2 && rect.height > 2;
}

function focusAfterThumbNav() {
    if (!quickViewDialog) return false;
    var info = quickViewDialog.querySelector('.Product__Info') || quickViewDialog.querySelector('.Product__InfoWrapper');
    var scope = info || quickViewDialog;
    var nodes = scope.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), lensadvizor-quick-buy, [tabindex="0"]');
    var target = null;
    Array.prototype.some.call(nodes, function(el) {
        if (isThumbFlowElement(el)) return false;
        if (el.classList.contains('close-quickview')) return false;
        if (el.classList.contains('Carousel') || el.classList.contains('Product__Slideshow')) return false;
        if (el.closest('.Product__Gallery, .thumbnail--slider-product, .qv-thumb-nav')) return false;
        if (!isVisiblyFocusable(el)) return false;
        target = el;
        return true;
    });
    if (!target) return false;
    target.focus();
    return document.activeElement === target || target.contains(document.activeElement);
}

function handleThumbCarouselTab(event) {
    var current = document.activeElement;
    if (!isThumbFlowElement(current)) return false;
    var isNext = current.classList.contains('qv-thumb-nav-next');
    var isPrev = current.classList.contains('qv-thumb-nav-prev');

    if (!event.shiftKey && (isNext || isPrev)) {
        pendingThumbNavRestore = null;
        if (focusAfterThumbNav()) {
            event.preventDefault();
            return true;
        }
        return false;
    }

    var flkty = getThumbFlickity(current);
    if (!flkty) return false;
    var buttons = getThumbNavButtons();
    var visible = getVisibleThumbCells(flkty);
    event.preventDefault();

    if (event.shiftKey) {
        if (isPrev) {
            if (visible.length) visible[0].focus();
            else focusAdjacentDialogControl(current, true);
            return true;
        }
        if (isNext) {
            if (visible.length) visible[visible.length - 1].focus();
            return true;
        }
        var shiftIndex = visible.indexOf(current);
        if (shiftIndex > 0) {
            visible[shiftIndex - 1].focus();
            return true;
        }
        if (buttons.prev && !buttons.prev.disabled) {
            buttons.prev.focus();
            return true;
        }
        focusAdjacentDialogControl(current, true);
        return true;
    }

    var index = visible.indexOf(current);
    if (index > -1 && index < visible.length - 1) {
        visible[index + 1].focus();
        return true;
    }
    if (buttons.next && !buttons.next.disabled) {
        buttons.next.focus();
        return true;
    }
    if (buttons.prev && !buttons.prev.disabled) {
        buttons.prev.focus();
        return true;
    }
    focusAdjacentDialogControl(current, false);
    return true;
}

function advanceThumbCarousel(direction) {
    var flkty = getThumbFlickity();
    if (!flkty) return;
    pendingThumbNavRestore = direction;
    if (direction === 'next') flkty.next();
    else flkty.previous();

    var afterMove = function() {
        if (afterMove.done) return;
        afterMove.done = true;
        syncThumbCarouselAria(flkty);
        restoreThumbNavFocus(direction);
    };
    var onSettle = function() {
        flkty.off('settle', onSettle);
        afterMove();
    };
    flkty.on('settle', onSettle);
    window.setTimeout(afterMove, 450);
}

function prepareQuickViewThumbnails() {
    if (!quickViewDialog) return;
    var slider = quickViewDialog.querySelector('.thumbnail--slider-product');
    var titleEl = quickViewDialog.querySelector('.ProductMeta__Title');
    var title = titleEl ? titleEl.textContent.trim() : 'Product';

    if (!slider) return;

    slider.setAttribute('role', 'region');
    slider.setAttribute('aria-roledescription', 'carousel');
    slider.setAttribute('aria-label', title + ' thumbnails');

    var track = slider.querySelector('.flickity-slider');
    if (track) {
        track.setAttribute('aria-live', 'off');
        track.setAttribute('aria-atomic', 'false');
    }

    // label each real slide with alt text + position
    var realCells = [];
    quickViewDialog.querySelectorAll('.thumbnail--slider-product .navigationthumbnail--media').forEach(function(cell) {
        if (!cell.classList.contains('flickity-clone')) realCells.push(cell);
    });
    var count = realCells.length;

    quickViewDialog.querySelectorAll('.thumbnail--slider-product .navigationthumbnail--media').forEach(function(cell) {
        if (cell.classList.contains('flickity-clone')) {
            cell.setAttribute('tabindex', '-1');
            cell.setAttribute('aria-hidden', 'true');
            return;
        }
        var idx = realCells.indexOf(cell);
        var img = cell.querySelector('img');
        var label = buildCarouselImageLabel(img ? img.getAttribute('alt') : '', title, idx, count);
        cell.setAttribute('tabindex', '-1');
        cell.setAttribute('role', 'group');
        cell.setAttribute('aria-roledescription', 'slide');
        cell.setAttribute('aria-label', label);
        if (img) img.setAttribute('alt', '');
    });

    var flkty = typeof Flickity !== 'undefined' ? Flickity.data(slider) : null;

    var navContainer = slider.parentElement;
    var navWrap = navContainer && navContainer.querySelector('.qv-thumb-nav');
    if (navContainer && !navWrap) {
        navWrap = document.createElement('div');
        navWrap.className = 'qv-thumb-nav';

        var prevBtn = navContainer.querySelector('.qv-thumb-nav-prev');
        var nextBtn = navContainer.querySelector('.qv-thumb-nav-next');
        if (!prevBtn) {
            prevBtn = document.createElement('button');
            prevBtn.type = 'button';
            prevBtn.className = 'qv-thumb-nav-prev';
            prevBtn.innerHTML = '&#8249;';
        }
        if (!nextBtn) {
            nextBtn = document.createElement('button');
            nextBtn.type = 'button';
            nextBtn.className = 'qv-thumb-nav-next';
            nextBtn.innerHTML = '&#8250;';
        }
        prevBtn.setAttribute('aria-label', (quickViewDialog && quickViewDialog.getAttribute('data-prev-thumbnail-label')) || 'Previous thumbnail slide');
        nextBtn.setAttribute('aria-label', (quickViewDialog && quickViewDialog.getAttribute('data-next-thumbnail-label')) || 'Next thumbnail slide');
        navWrap.appendChild(prevBtn);
        navWrap.appendChild(nextBtn);

        if (slider.nextSibling) {
            navContainer.insertBefore(navWrap, slider.nextSibling);
        } else {
            navContainer.appendChild(navWrap);
        }
    } else if (navWrap) {
        var existingPrev = navWrap.querySelector('.qv-thumb-nav-prev');
        var existingNext = navWrap.querySelector('.qv-thumb-nav-next');
        if (existingPrev) {
            existingPrev.setAttribute('aria-label', (quickViewDialog && quickViewDialog.getAttribute('data-prev-thumbnail-label')) || 'Previous thumbnail slide');
        }
        if (existingNext) {
            existingNext.setAttribute('aria-label', (quickViewDialog && quickViewDialog.getAttribute('data-next-thumbnail-label')) || 'Next thumbnail slide');
        }
        if (existingPrev && existingNext && existingPrev.nextElementSibling !== existingNext) {
            navWrap.insertBefore(existingPrev, existingNext);
        }
    }

    // announce position change via live region
    var statusEl = navContainer && navContainer.querySelector('.qv-thumb-status');
    if (navContainer && !statusEl) {
        statusEl = document.createElement('div');
        statusEl.className = 'qv-thumb-status';
        statusEl.setAttribute('role', 'status');
        statusEl.setAttribute('aria-live', 'polite');
        statusEl.setAttribute('aria-atomic', 'true');
        statusEl.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;';
        navContainer.appendChild(statusEl);
    }

    if (flkty) {
        flkty.select(0, false, true);
        syncThumbCarouselAria(flkty);

        flkty.off('select', flkty._randolphThumbAria);
        flkty._randolphThumbAria = function() { syncThumbCarouselAria(flkty); };
        flkty.on('select', flkty._randolphThumbAria);
        flkty.on('settle', flkty._randolphThumbAria);
        window.setTimeout(function() { syncThumbCarouselAria(flkty); }, 50);

        // announce current position when slide changes
        if (statusEl) {
            flkty.off('select', flkty._randolphThumbAnnounce);
            flkty._randolphThumbAnnounce = function() {
                var selected = flkty.selectedElement;
                if (!selected || selected.classList.contains('flickity-clone')) return;
                var pos = realCells.indexOf(selected);
                if (pos < 0) return;
                var msg = 'Thumbnail ' + (pos + 1) + ' of ' + count;
                statusEl.textContent = '';
                setTimeout(function() { statusEl.textContent = msg; }, 50);
            };
            flkty.on('select', flkty._randolphThumbAnnounce);
        }
    }
}

function activateQuickViewFocus(opener, isNestedOpen) {
    if (!isNestedOpen) {
        quickViewOpener = opener || null;
    }
    if (quickViewOpener) {
        quickViewOpener.removeAttribute('aria-expanded');
    }
    quickViewDialog = document.querySelector('.quick-view-container');
    if (!quickViewDialog) return;
    quickViewDialog.setAttribute('tabindex', '-1');
    hidePageFromScreenReaders();
    document.removeEventListener('keydown', onQuickViewKeydown, true);
    document.addEventListener('keydown', onQuickViewKeydown, true);
    ensureQuickViewTabControlsA11y();
    prepareQuickViewCarousel();
    prepareQuickViewThumbnails();
    focusQuickViewClose();
    window.requestAnimationFrame(function() {
        focusQuickViewClose();
        window.setTimeout(focusQuickViewClose, 50);
        window.setTimeout(focusQuickViewClose, 250);
    });
}

document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.quickview-pdp');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();

    var loadingBar = document.querySelector('.LoadingBar');
    var isNestedOpen = !!document.querySelector('.quick-view-popup.active');
    var productHandle = trigger.getAttribute('data-product-handle');
    var productUrl = '/products/' + productHandle;

    if (loadingBar) loadingBar.classList.add('popup-loading');

    fetch(productUrl, { credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (response) {
            var parsed = document.createElement('div');
            parsed.innerHTML = response;
            var productSection = parsed.querySelector('section.Product, [data-section-type="product"]');
            var reponsePdp = productSection ? productSection.innerHTML : '';
            var inner = document.querySelector('.quick-view-popup .quick-view-inner');
            if (inner) inner.innerHTML = reponsePdp;

            document.querySelectorAll('.quick-view-inner h1.ProductMeta__Title').forEach(function (headingEl) {
                var heading = document.createElement('h2');
                heading.className = headingEl.className;
                while (headingEl.firstChild) heading.appendChild(headingEl.firstChild);
                headingEl.parentNode.replaceChild(heading, headingEl);
            });

            initializeYcabCarousels(document.querySelector('.quick-view-inner'));
            if (loadingBar) loadingBar.classList.add('popup-loaded');
            setTimeout(function () {
                if (loadingBar) loadingBar.classList.remove('popup-requested', 'popup-loaded', 'popup-loading');
            }, 1000);

            var popup = document.querySelector('.quick-view-popup');
            if (popup) popup.classList.add('active');
            document.body.classList.add('quick-view-activated');
            revealQuickViewImages(inner);
            syncQuickViewSlideshowNav();
            initializeFlickity();
            var dialogName = trigger.getAttribute('aria-label') || 'Quick view';
            var container = document.querySelector('.quick-view-container');
            if (container) {
                container.removeAttribute('aria-hidden');
                container.setAttribute('aria-label', dialogName);
            }
            ensureQuickViewTabControlsA11y();
            activateQuickViewFocus(trigger, isNestedOpen);

            var optionOneValueEl = document.querySelector('.HorizontalList__Item input[name="option-0"]:checked');
            var optionTwoValueEl = document.querySelector('.HorizontalList__Item input[name="option-1"]:checked');
            var optionOneValue = optionOneValueEl ? optionOneValueEl.value : '';
            var optionTwoValue = optionTwoValueEl ? optionTwoValueEl.value : '';

            document.querySelectorAll('.HorizontalList__Item input[name="option-0"]').forEach(function (input) {
                input.addEventListener('change', function () {
                    if (this.checked) optionOneValue = this.value;
                });
            });
            document.querySelectorAll('.HorizontalList__Item input[name="option-1"]').forEach(function (input) {
                input.addEventListener('change', function () {
                    if (this.checked) optionTwoValue = this.value;
                });
            });
            document.querySelectorAll('.HorizontalList__Item input').forEach(function (input) {
                input.addEventListener('change', function () {
                    var checkedValue = optionOneValue + ' / ' + optionTwoValue;
                    document.querySelectorAll('.productselectors option').forEach(function (opt) {
                        if (opt.textContent.indexOf(checkedValue) !== -1) opt.selected = true;
                    });
                });
            });

            document.querySelectorAll('.ProductForm__BuyButtons').forEach(function (el) {
                el.classList.remove('lensActive');
            });
            document.querySelectorAll('lensadvizor-quick-buy').forEach(function (el) {
                el.classList.add('hidelens');
            });
            if (parsed.querySelector('lensadvizor-quick-buy')) {
                var buyButtons = document.querySelector('.quick-view-container .ProductForm__BuyButtons');
                if (buyButtons) {
                    var rxLink = document.createElement('a');
                    rxLink.href = productUrl;
                    rxLink.className = 'Button Button--primary prescriptionRedirect';
                    rxLink.tabIndex = 0;
                    rxLink.textContent = 'ADD Prescription';
                    buyButtons.appendChild(rxLink);
                }
            }

            return fetch(productUrl + '.json', { credentials: 'same-origin' }).then(function (res) { return res.json(); });
        })
        .then(function (json) {
            if (!json || !json.product) return;
            var thumbSlider = '';
            var productTitle = json.product.title || '';
            json.product.images.forEach(function (image) {
                var imageAlt = (image.alt && image.alt.trim()) ? image.alt.trim() : productTitle;
                var safeAlt = imageAlt.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
                thumbSlider +=
                    '<div class="navigationthumbnail--media carousel-cell">' +
                    '<img src="' + image.src + '" loading="lazy" width="100" height="100" alt="' + safeAlt + '">' +
                    '</div>';
            });
            var gallery = document.querySelector('.quick-view-container .Product__Gallery');
            if (gallery) {
                var wrap = document.createElement('div');
                wrap.innerHTML = '<div class="thumbnail--slider-product">' + thumbSlider + '</div>';
                gallery.appendChild(wrap.firstChild);
            }
            initializeThumbanil();
            prepareQuickViewThumbnails();
            focusQuickViewClose();
        })
        .catch(function (error) {
            console.error('An error occurred: ' + error);
        });
});

function closeQuickView() {
    var popup = document.querySelector('.quick-view-popup');
    var wasOpen = !!(popup && popup.classList.contains('active'));
    document.removeEventListener('keydown', onQuickViewKeydown, true);
    if (quickViewOpener) {
        quickViewOpener.removeAttribute('aria-expanded');
    }
    if (popup) popup.classList.remove('active');
    document.body.classList.remove('quick-view-activated');
    // Clear any leftover inline overflow from details/fit-guide drawer
    document.body.style.removeProperty('overflow');
    if (typeof window.closeDetailsDrawer === 'function') {
        window.closeDetailsDrawer();
    }
    var inner = document.querySelector('.quick-view-popup .quick-view-inner');
    if (inner) inner.innerHTML = '';
    var container = document.querySelector('.quick-view-container');
    if (container) container.setAttribute('aria-hidden', 'true');
    if (quickViewDialog) {
        quickViewDialog.removeAttribute('tabindex');
    }
    // Must run before focusing the opener, which sits inside the hidden page.
    releasePageFromScreenReaders();
    if (wasOpen && quickViewOpener && document.contains(quickViewOpener) && typeof quickViewOpener.focus === 'function') {
        try {
            quickViewOpener.focus({ preventScroll: true });
        } catch (err) {
            quickViewOpener.focus();
        }
    }
    quickViewOpener = null;
    quickViewDialog = null;
}

document.addEventListener('click', function (event) {
    if (event.target.closest('.close-quickview')) closeQuickView();
});

/**
 * Issue 96: Live flow submits the form and redirects to the cart page.
 * Announce success to screen readers briefly before that redirect — no drawer, no Ajax cart.
 */
function announceQuickViewAddedToCart(message) {
    var dialog = document.getElementById('quick-view-dialog');
    if (!dialog || !message) return;

    var region = document.getElementById('quick-view-cart-status');
    if (!region) {
        region = document.createElement('div');
        region.id = 'quick-view-cart-status';
        region.className = 'u-visually-hidden';
        dialog.insertBefore(region, dialog.firstChild);
    }

    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    region.textContent = '';
    window.setTimeout(function() {
        region.textContent = message;
    }, 50);
}

document.addEventListener('click', function (e) {
    var atc = e.target.closest('.quick-view-container [data-action="add-to-cart"]');
    if (!atc) return;
    var form = atc.closest('form[action*="/cart/add"]');
    if (!form || !form.closest('.quick-view-container')) return;
    if (form.getAttribute('data-a11y-atc-announced') === 'true') return;

    e.preventDefault();
    e.stopPropagation();

    var message =
        (window.languages && window.languages.productAddedToCart) ||
        'Product added to cart';
    var titleEl = document.querySelector('.quick-view-inner .ProductMeta__Title');
    var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
    if (title && window.languages && window.languages.productAddedToCartNamed) {
        message = window.languages.productAddedToCartNamed.replace('TITLE', title);
    } else if (title) {
        message = title + ' added to cart';
    }

    announceQuickViewAddedToCart(message);
    form.setAttribute('data-a11y-atc-announced', 'true');

    // Brief pause so VoiceOver / NVDA can speak before the cart redirect
    window.setTimeout(function() {
        HTMLFormElement.prototype.submit.call(form);
    }, 1000);
});

document.addEventListener('click', function (e) {
    if (e.target.closest('.quick-view-popup, .quickview-pdp, .pdp_details_drawer')) {
        return;
    }
    closeQuickView();
});


function whenFlickityReady(callback) {
    if (typeof Flickity !== 'undefined') {
        callback();
        return;
    }
    var tries = 0;
    var timer = setInterval(function () {
        tries += 1;
        if (typeof Flickity !== 'undefined' || tries > 120) {
            clearInterval(timer);
            if (typeof Flickity !== 'undefined') callback();
        }
    }, 25);
}

function revealQuickViewImages(root) {
    if (!root) return;
    root.querySelectorAll('.Product__Slideshow img.Image--lazyLoad, .Product__Slideshow img[data-src], .Product__Slideshow img[data-original-src]').forEach(function (img) {
        var currentSrc = img.getAttribute('src') || '';
        var original = img.getAttribute('data-original-src');
        var dataSrc = img.getAttribute('data-src') || '';
        if (!currentSrc || currentSrc.indexOf('1x1') !== -1) {
            if (original) {
                img.setAttribute('src', original);
            } else if (dataSrc) {
                img.setAttribute('src', dataSrc.replace('{width}', '800').replace('%7Bwidth%7D', '800'));
            }
        }
        img.classList.add('Image--lazyLoaded', 'lazyloaded');
        img.classList.remove('Image--lazyLoad', 'lazyload', 'Image--lazyLoading');
    });
    if (window.lazySizes && window.lazySizes.loader) {
        root.querySelectorAll('img.Image--lazyLoad, img.lazyload').forEach(function (img) {
            try { window.lazySizes.loader.unveil(img); } catch (err) {}
        });
    }
}

function resizeQuickViewFlickity(el) {
    if (!el || typeof Flickity === 'undefined') return;
    var instance = Flickity.data(el);
    if (instance) instance.resize();
}

function initializeFlickity(done) {
    whenFlickityReady(function () {
        window.requestAnimationFrame(function () {
            var slideshows = document.querySelectorAll('.quick-view-inner .Product__Slideshow');
            if (!slideshows.length) {
                slideshows = document.querySelectorAll('.quick-view-inner .Carousel');
            }
            slideshows.forEach(function (el) {
                if (el.classList.contains('VariantSelector__Carousel')) return;
                if (Flickity.data(el)) {
                    Flickity.data(el).resize();
                    syncQuickViewSlideshowNav(Flickity.data(el));
                    return;
                }
                if (!el.querySelector('.Carousel__Cell, .Product__SlideItem')) return;
                var flkty = new Flickity(el, {
                    cellAlign: 'left',
                    contain: true,
                    prevNextButtons: false,
                    pageDots: false,
                    wrapAround: true,
                    adaptiveHeight: true,
                    watchCSS: false,
                    accessibility: false
                });
                flkty.on('select', function () {
                    syncQuickViewSlideshowNav(flkty);
                    highlightQuickViewThumbnail(flkty.selectedIndex);
                });
                resizeQuickViewFlickity(el);
                syncQuickViewSlideshowNav(flkty);
                el.querySelectorAll('img').forEach(function (img) {
                    if (img.complete) return;
                    img.addEventListener('load', function () {
                        resizeQuickViewFlickity(el);
                    }, { once: true });
                });
            });
            syncQuickViewSlideshowNav();
            window.setTimeout(function () {
                document.querySelectorAll('.quick-view-inner .Product__Slideshow').forEach(resizeQuickViewFlickity);
                syncQuickViewSlideshowNav();
            }, 50);
            window.setTimeout(function () {
                document.querySelectorAll('.quick-view-inner .Product__Slideshow').forEach(resizeQuickViewFlickity);
                syncQuickViewSlideshowNav();
            }, 250);
            if (typeof done === 'function') done();
        });
    });
}
function initializeThumbanil() {
    whenFlickityReady(function () {
        var main = getQuickViewMainSlideshow();
        if (main && !Flickity.data(main)) {
            window.setTimeout(initializeThumbanil, 50);
            return;
        }
        document.querySelectorAll('.thumbnail--slider-product').forEach(function (el) {
            if (Flickity.data(el) || el.classList.contains('flickity-enabled')) return;
            new Flickity(el, {
                contain: true,
                pageDots: false,
                wrapAround: false,
                cellAlign: 'left',
                prevNextButtons: false,
                accessibility: false
            });
        });
    });
}

function initializeYcabCarousels(root) {
    if (!root) return;
    var start = function () {
        if (typeof Swiper === 'undefined') return;
        root.querySelectorAll('.flyout-ycab').forEach(function (ycabRoot) {
            var swiperEl = ycabRoot.querySelector('.flyout-ycab__swiper');
            var prevBtn = ycabRoot.querySelector('.flyout-ycab__nav-btn--prev');
            var nextBtn = ycabRoot.querySelector('.flyout-ycab__nav-btn--next');
            if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;
            var productCount = parseInt(ycabRoot.getAttribute('data-product-count'), 10) || 0;
            if (!productCount) productCount = swiperEl.querySelectorAll('.swiper-slide').length;
            new Swiper(swiperEl, {
                slidesPerView: 2.5,
                spaceBetween: 14,
                watchOverflow: true,
                navigation: { nextEl: nextBtn, prevEl: prevBtn },
                breakpoints: {
                    0: { slidesPerView: Math.min(2.1, Math.max(1, productCount)), spaceBetween: 12 },
                    480: { slidesPerView: Math.min(2.5, productCount), spaceBetween: 14 },
                    768: { slidesPerView: Math.min(2.7, productCount), spaceBetween: 16 }
                }
            });
        });
    };
    if (typeof Swiper !== 'undefined') {
        start();
        return;
    }
    if (typeof window.whenSwiperReady === 'function') {
        window.whenSwiperReady(start);
        return;
    }
    var tries = 0;
    var timer = setInterval(function () {
        tries += 1;
        if (typeof Swiper === 'undefined' && tries <= 120) return;
        clearInterval(timer);
        if (typeof Swiper !== 'undefined') start();
    }, 25);
}

document.addEventListener('click', function (event) {
    var popup = document.querySelector('.quick-view-popup.active');
    if (!popup || !popup.contains(event.target)) return;
    if (event.target.closest('.qv-thumb-nav, .flyout-ycab, .thumbnail--slider-product')) return;

    var prev = event.target.closest('[data-action="carousel-previous"], .Product__SlideshowNavArrow--previous, .Product__SlideshowNavArrow[data-direction="previous"]');
    var next = event.target.closest('[data-action="carousel-next"], .Product__SlideshowNavArrow--next, .Product__SlideshowNavArrow[data-direction="next"]');
    if (!prev && !next) return;
    var btn = next || prev;
    if (!popup.contains(btn)) return;
    event.preventDefault();
    event.stopPropagation();
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    navigateQuickViewSlideshow(next ? 'next' : 'previous');
});

document.addEventListener('click', function (event) {
    var thumb = event.target.closest('.quick-view-popup.active .navigationthumbnail--media');
    if (!thumb || thumb.classList.contains('flickity-clone')) return;
    var slider = thumb.closest('.thumbnail--slider-product');
    if (!slider) return;
    var cells = Array.prototype.filter.call(slider.querySelectorAll('.navigationthumbnail--media'), function (cell) {
        return !cell.classList.contains('flickity-clone');
    });
    var index = cells.indexOf(thumb);
    var flkty = getQuickViewCarousel();
    if (flkty && index >= 0) flkty.select(index);
});

document.addEventListener('click', function (event) {
    if (event.target.closest('.qv-thumb-nav-next')) {
        event.preventDefault();
        advanceThumbCarousel('next');
    }
    if (event.target.closest('.qv-thumb-nav-prev')) {
        event.preventDefault();
        advanceThumbCarousel('prev');
    }
});

document.addEventListener('keydown', function (event) {
    var media = event.target.closest && event.target.closest('.thumbnail--slider-product .navigationthumbnail--media');
    if (!media) return;
    if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        media.click();
        return;
    }
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' && event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
    var flkty = getThumbFlickity(media);
    if (!flkty) return;
    var visible = getVisibleThumbCells(flkty);
    var index = visible.indexOf(media);
    if (index < 0) return;
    event.preventDefault();
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        if (index < visible.length - 1) {
            visible[index + 1].focus();
            return;
        }
        var nextBtn = getThumbNavButtons().next;
        if (nextBtn && !nextBtn.disabled) nextBtn.focus();
        return;
    }
    if (index > 0) {
        visible[index - 1].focus();
        return;
    }
    var prevBtn = getThumbNavButtons().prev;
    if (prevBtn && !prevBtn.disabled) prevBtn.focus();
});
